import React from 'react';

import { FormCardContainer } from './card';

const FormCard = ({ children, type }) => (
  <FormCardContainer type={type}>{children}</FormCardContainer>
);

export default FormCard;
